import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
// import useStyles from "../common/Styles";

const TribesMetric = () => {
  const { tribe_selected, tribe_metrics } = useSelector((state) => state.water_user);
  const classes = {
    aboutBox: { height: "80%", overflow: "auto" },
    metricTitle: {
      fontSize: 18,
      fontWeight: "bold",
      color: "#2352D0",
      marginBottom: 32,
      marginTop: 40
    },
    metricSubTitle: { fontSize: "16", color: "#000000", marginBottom: 8 },
    metricValue: {
      fontSize: 24,
      fontWeight: "bold",
      color: "#000000",
      marginBottom: "2vh",
    },
    operator: {
      fontSize: "2.5vh",
      fontWeight: "bold",
      color: "#000000",
      marginBottom: "2vh",
    },
  };

  return (
    <Grid item xs={12} className={classes.aboutBox}>
      <Typography variant="h5" component="p" style={classes.metricTitle}>
        {tribe_selected.name}
      </Typography>
      <Typography
        variant="body2"
        component="div"
        style={classes.metricSubTitle}
      >
        Total Contract Entitlement
      </Typography>
      <Typography variant="h6" component="div" style={classes.metricValue}>
        {Math.round(tribe_metrics.total_contract_entitlement).toLocaleString("en-US")} acre-feet
      </Typography>
      {/* <Typography variant="h6" component="div" style={classes.operator}>
        +
      </Typography>
      <Typography
        variant="body2"
        component="div"
        style={classes.metricSubTitle}
      >
        Indian Priority
      </Typography>
      <Typography variant="h6" component="div" style={classes.metricValue}>
        191,200
      </Typography> */}
      <Typography variant="h6" component="div" style={classes.operator}>
        {tribe_metrics.leases_and_exchanges>0 ? "+" : "-"}
      </Typography>
      <Typography
        variant="body2"
        component="div"
        style={classes.metricSubTitle}
      >
        Exchanges and Leases
      </Typography>
      <Typography variant="h6" component="div" style={classes.metricValue}>
        {Math.abs(tribe_metrics.leases_and_exchanges).toLocaleString("en-US")} acre-feet
      </Typography>
      <Typography variant="h6" component="div" style={classes.operator}>
        =
      </Typography>
      <Typography
        variant="body2"
        component="div"
        style={classes.metricSubTitle}
      >
        Total Access Balance
      </Typography>
      <Typography variant="h6" component="div" style={classes.metricValue}>
        {Math.round(tribe_metrics.total_access_colorado_water).toLocaleString("en-US")} acre-feet
      </Typography>
    </Grid>
  );
};

export default TribesMetric;
